import { createFileRoute } from '@tanstack/react-router';
import { safeInternalPath } from '@/shared/lib/safeInternalPath';
import { LoginRouteComponent } from './-LoginRouteComponent';

/** 보호 라우트가 실어 보낸 목적지. optional 이어야 기존 `to: '/login'` 이동이 그대로 유효하다. */
interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute('/login')({
  // 외부 URL·비-http 스킴은 safeInternalPath 가 떨어뜨린다 (오픈 리다이렉트 차단).
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    const redirect = safeInternalPath(search.redirect);
    return redirect ? { redirect } : {};
  },
  component: LoginRouteComponent,
});
